import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import Login from '@/views/login'
// 加载根组件
// const Login = r => require.ensure([], () => r(require('@/views/login')), 'login')

const Index = r => require.ensure([], () => r(require('@/views/index')), 'index')
const Detail = r => require.ensure([], () => r(require('@/views/prodcuts/detail')), 'detail')
const GoodsAll = r => require.ensure([], () => r(require('@/views/prodcuts/goods-all')), 'goods-all')
const GoodsCar = r => require.ensure([], () => r(require('@/views/prodcuts/goods-car')), 'goods-car')

const ConfirmOrders = r => require.ensure([], () => r(require('@/views/prodcuts/confirm-orders')), 'confirm-orders')
const GYM = r => require.ensure([], () => r(require('@/views/about/gym')), 'gym')
const US = r => require.ensure([], () => r(require('@/views/about/us')), 'us')

const intro = r => require.ensure([], () => r(require('@/views/cooperate/intro')), 'intro')
const dataform = r => require.ensure([], () => r(require('@/views/cooperate/dataform')), 'dataform')


const Login = r => require.ensure([], () => r(require('@/views/login')), 'login')
const Arrondi = r => require.ensure([], () => r(require('@/views/prodcuts/arrondi')), 'arrondi')
const BrandList = r => require.ensure([], () => r(require('@/views/prodcuts/list')), 'brand-list')
const SearchList = r => require.ensure([], () => r(require('@/views/prodcuts/search-list')), 'search-list')
const LiveList = r => require.ensure([], () => r(require('@/views/live/list')), 'live-list')
const Player = r => require.ensure([], () => r(require('@/views/live/player')), 'player')






Vue.use(Router)

export default new Router({

  base: '/',
  routes: [
    {
      path: '/',
      name: '主页',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/goods-all',
      name: 'GoodsAll',
      component: GoodsAll
    },
    {
      path: '/goods-car',
      name: 'GoodsCar',
      component: GoodsCar
    },
    {
      path: '/confirm-orders',
      name: 'ConfirmOrders',
      component: ConfirmOrders
    },
    {
      path: '/gym',
      name: 'GYM',
      component: GYM
    },
    {
      path: '/us',
      name: 'US',
      component: US
    },
    {
      path: '/intro',
      name: 'intro',
      component: intro
    },
    {
      path: '/dataform',
      name: 'dataform',
      component: dataform
    },

    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/arrondi',
      name: 'Arrondi',
      component: Arrondi
    },
    {
      path: '/brand-list',
      name: 'BrandList',
      component: BrandList
    },
    {
      path: '/search-list',
      name: 'SearchList',
      component: SearchList
    },
    {
      path: '/live-list',
      name: 'LiveList',
      component: LiveList
    },
    {
      path: '/player',
      name: 'Player',
      component: Player
    },

    // {
    //   path: '/liveRoomLst',
    //   name: 'liveRoomLst',
    //   component: liveRoomLst
    // }, {
    //   path: '/live/setting',
    //   name: 'setting',
    //   component: setting
    // }, {
    //   path: '/user/wechat',
    //   name: 'wechat',
    //   component: wechat
    // }, {
    //   path: '/user/member',
    //   name: 'member',
    //   component: member
    // },
    // {
    //   path: '/user/subAdd',
    //   name: 'subAdd',
    //   component: subAdd
    // }
    //
    // , {
    //   path: '/user/sysuser',
    //   name: 'sysuser',
    //   component: sysuser
    // }, {
    //   path: '/goods/goodsLst',
    //   name: 'goodsLst',
    //   component: goodsLst
    // }, {
    //   path: '/analysis/goodsView',
    //   name: 'goodsView',
    //   component: goodsView
    // }, {
    //   path: '/analysis/userView',
    //   name: 'userView',
    //   component: userView
    // }, {
    //   path: '/analysis/dayView',
    //   name: 'dayView',
    //   component: dayView
    // }, {
    //   path: '/analysis/dayGoodsView',
    //   name: 'dayGoodsView',
    //   component: dayGoodsView
    // }, {
    //   path: '/analysis/visitView',
    //   name: 'visitView',
    //   component: visitView
    // }, {
    //   path: '/analysis/newUserView',
    //   name: 'newUserView',
    //   component: newUserView
    // }
    //
    // , {
    //   path: '/goods/goodsAdd',
    //   name: 'goodsAdd',
    //   component: goodsAdd
    // }, {
    //   path: '/goods/category/typeLst',
    //   name: 'typeLst',
    //   component: typeLst
    // }, {
    //   path: '/goods/goodsScore/goodsScore',
    //   name: 'goodsScore',
    //   component: goodsScore
    // },  {
    //   path: '/goods/bargaining/bargaining',
    //   name: 'bargaining',
    //   component: bargaining
    // },{
    //   path: '/goods/stock/stockLst',
    //   name: 'stockLst',
    //   component: stockLst
    // }, {
    //   path: '/goods/stock/stockAdd',
    //   name: 'stockAdd',
    //   component: stockAdd
    // }, {
    //   path: '/goods/coupon/couponLst',
    //   name: 'couponLst',
    //   component: couponLst
    // }, {
    //   path: '/goods/coupon/business',
    //   name: 'business',
    //   component: business
    // }, {
    //   path: '/orders/orderLst',
    //   name: 'orderLst',
    //   component: orderLst
    // },{
    //   path: '/orders/orderLstNew',
    //   name: 'orderLstNew',
    //   component: orderLstNew
    // },{
    //   path: '/orders/scoreOrdLst',
    //   name: 'scoreOrdLst',
    //   component: scoreOrdLst
    // },{
    //   path: '/orders/bargainOrdLst',
    //   name: 'bargainOrdLst',
    //   component: bargainOrdLst
    // },
    //
    // {
    //   path: '/fame/fameLst',
    //   name: 'fameLst',
    //   component: fameLst
    // }, {
    //   path: '/sixPlate/plateLst',
    //   name: 'plateLst',
    //   component: plateLst
    // }, {
    //   path: '/banner/bannerLst',
    //   name: 'bannerLst',
    //   component: bannerLst
    // }
    // , {
    //   path: '/goods/success',
    //   name: 'success',
    //   component: success
    // }, {
    //   path: '/orders/logistics/logisticsLst',
    //   name: 'logisticsLst',
    //   component: logisticsLst
    // }, {
    //   path: '/orders/member/memberLst',
    //   name: 'memberLst',
    //   component: memberLst
    // }, {
    //   path: '/orders/logistics/logisticsAdd',
    //   name: 'logisticsAdd',
    //   component: logisticsAdd
    // },
    // {
    //   path: '/hotspot/imageTemplate',
    //   name: 'imageTemplate',
    //   component: imageTemplate
    // },
    // {
    //   path: '/hotspot/imageTemplateAdd',
    //   name: 'imageTemplateAdd',
    //   component: imageTemplateAdd
    // },
    // {
    //   path: '/hotspot/imagesLst',
    //   name: 'imagesLst',
    //   component: imagesLst
    // },
    // {
    //   path: '/hotspot/imageAdd',
    //   name: 'imageAdd',
    //   component: imageAdd
    // },
    // {
    //   path: '/hotspot/preview',
    //   name: 'preview',
    //   component: preview
    // },
    // {
    //   path: '/goods/module/moduleLst',
    //   name: 'moduleLst',
    //   component: moduleLst
    // },
    // {
    //   path: '/hotspot/pageConfig',
    //   name: 'pageConfig',
    //   component: pageConfig
    // },
    // {
    //   path: '/hotspot/usersingup',
    //   name: 'usersingup',
    //   component: usersingup
    // },
    // {
    //   path: '/hotspot/answer',
    //   name: 'answer',
    //   component: answer
    // },
    // {
    //   path: '/hotspot/recruitLst',
    //   name: 'recruitLst',
    //   component: recruitLst
    // },
    //
    // {
    //   path: '/hotspot/pageConfigAdd',
    //   name: 'pageConfigAdd',
    //   component: pageConfigAdd
    // },
    // {
    //   path: '/hotspot/formConfig',
    //   name: 'formConfig',
    //   component: formConfig
    // },
    // {
    //   path: '/hotspot/formConfigAdd',
    //   name: 'formConfigAdd',
    //   component: formConfigAdd
    // },
    //
    // {
    //   path: '/course/school',
    //   name: 'school',
    //   component: school
    // }
    // ,   {
    //   path: '/course/subject',
    //   name: 'subject',
    //   component: subject
    // },
    // {
    //   path: '/course/subjectCategory',
    //   name: 'subjectCategory',
    //   component: subjectCategory
    // },
    // {
    //   path: '/course/schoolAdd',
    //   name: 'schoolAdd',
    //   component: schoolAdd
    // },
    // {
    //   path: '/course/subjectAdd',
    //   name: 'subjectAdd',
    //   component: subjectAdd
    // },
    // {
    //   path: '/vote/activeLst',
    //   name: 'active',
    //   component: active
    // },
    // {
    //   path: '/vote/giftLst',
    //   name: 'gift',
    //   component: gift
    // },
    // {
    //   path: '/vote/playerLst',
    //   name: 'player',
    //   component: player
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js